import type { ReactNode } from "react";

export function Spinner() {
  return <div className="spinner" role="status" aria-label="불러오는 중" />;
}

export function Centered({ children }: { children: ReactNode }) {
  return <div className="centered">{children}</div>;
}
